import axios from "axios";
import { jwtDecode } from "jwt-decode";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT

export const getLogin = async (request) => {
	const headers = {
		'Content-Type': "application/json"
	};

	let url = apiUrl + "/authenticate-login";

	if (enviromentUrl !== "") {
		url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`;
	}

	try {
		const res = await axios.post(url, JSON.stringify(request), { headers });

		const data = {
			userAuthenticated: false,
			secondAuthRequired: false
		};

		const authHeader = res.headers?.authorization;
		if (authHeader) {
			const token = authHeader.replace('Bearer ', '');
			const decoded = jwtDecode(token);
			const userId = decoded.id;

			data.userAuthenticated = true;
			data.location = res.headers.location;
			data.headersSetCookie = authHeader;
			data.secondAuthRequired = false

			let secondUrl = apiUrl + "/opa-user/" + userId;
			if (enviromentUrl !== "") {
				secondUrl += secondUrl.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`;
			}
			const secondHeader = {
				'Content-Type': "application/json",
				Authorization: `Bearer ${authHeader}`,
				"X-RealmUuid": userId,
			};

			const userRes = await axios.get(secondUrl, { headers: secondHeader });
			data.additionalUserData = {
				...userRes.data,
				permissionsByAccount: userRes.data.permissionsByAccount?.filter(
					account => account.accountOriginSystem === "A2"
				) || []
			};
		} else if (res.data.interimToken) {
			data.userAuthenticated = false
			data.secondAuthRequired = true
			data.method = res.data.method
			data.interimToken = res.data.interimToken
			data.showQrAuth = res.data.status === "2FA_SETUP_PENDING" ? true : false
		} else {
			Object.assign(data, res.data);
		}

		return data;

	} catch (err) {
		return {
			userAuthenticated: false,
			error: true,
			loginInProcess: false,
			errorCode: "API General Error"
		};
	}
};

export const forgot = async (request) => {
	const headers = {
		'Content-Type': "application/json"
	};
	let url = apiUrl + "/recover-password";

	if (enviromentUrl !== "") {
		url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`;
	}
	try {
		const res = await axios.post(url, JSON.stringify(request), { headers });
		return res.status;
	} catch (err) {
		return err.response?.status || 500;
	}
};

export const reset = async (request) => {
	const headers = {
		'Content-Type': "application/json"
	};
	let url = apiUrl + "/update-password";

	if (enviromentUrl !== "") {
		url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`;
	}

	try {
		const res = await axios.post(url, JSON.stringify(request), { headers: headers })
		return {
			status: res.status,
			message: res.data?.message || "Password reset successful."
		};
	} catch (err) {
		return {
			status: err.response?.status || 500,
			message: err.response?.data?.message || "We were unable to process your request."
		};
	}
}

export const validateResetToken = async (request) => {
	const headers = {
		'Content-Type': "application/json"
	};
	let url = apiUrl + "/validate-hash";

	if (enviromentUrl !== "") {
		url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`;
	}

	try {
		const res = await axios.post(url, JSON.stringify(request), { headers: headers })
		return res.status;
	} catch (err) {
		return err.response?.status || 500;
	}
};

export const verify2fa = async (request) => {
	const headers = {
		'Content-Type': "application/json"
	};

	let url = apiUrl + "/verify-2fa";

	if (enviromentUrl !== "") {
		url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`;
	}

	try {
		const res = await axios.post(url, JSON.stringify(request), { headers });

		const data = {
			userAuthenticated: false,
		};

		if (res.headers.authorization !== undefined) {
			const token = res.headers.authorization.replace('Bearer ', '');
			const decoded = jwtDecode(token);
			const userId = decoded.id;

			data.userAuthenticated = true;
			data.location = res.headers.location;
			data.headersSetCookie = res.headers.authorization;

			let secondUrl = apiUrl + "/opa-user/" + userId;
			if (enviromentUrl !== "") {
				secondUrl += secondUrl.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`;
			}
			const secondHeader = {
				'Content-Type': "application/json",
				Authorization: `Bearer ${res.headers.authorization}`,
				"X-RealmUuid": userId,
			};

			const userRes = await axios.get(secondUrl, { headers: secondHeader });
			data.additionalUserData = {
				...userRes.data,
				permissionsByAccount: userRes.data.permissionsByAccount?.filter(
					account => account.accountOriginSystem === "A2"
				) || []
			};
		} else {
			Object.assign(data, res.data);
		}

		return data;

	} catch (err) {
		return {
			userAuthenticated: false,
			error: true,
			loginInProcess: false,
			errorCode: "API General Error"
		};
	}
};

export const getQrImageFor2faSetup = async (request) => {
	const headers = {
		'Content-Type': "application/json"
	};

	let url = apiUrl + "/setup-totp";

	if (enviromentUrl !== "") {
		url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`;
	}

	try {
		const res = await axios.post(url, JSON.stringify(request), { headers: headers })
		return res.data;
	} catch (err) {
		throw new Error(`Error ${err.response?.status || 500}`);
	}
}

